import { render, staticRenderFns } from "./merchantReview.vue?vue&type=template&id=130bd022&scoped=true&"
import script from "./merchantReview.vue?vue&type=script&lang=js&"
export * from "./merchantReview.vue?vue&type=script&lang=js&"
import style0 from "./merchantReview.vue?vue&type=style&index=0&id=130bd022&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130bd022",
  null
  
)

export default component.exports